import { useLocation, useParams } from 'react-router';
import { productSlugStore } from '@/store/productSlugStore';
import { QueryClient } from '@tanstack/react-query';
import type { ApiSuccessResponse } from '@/types/api/shared';
import type { IOrder } from '@/types/api/order/details';

export const useResolvedProductSlug = (): string | undefined | null => {
  const queryClient = new QueryClient();
  const { pathname } = useLocation();
  const { slug: paramSlug } = useParams<{ slug?: string }>();
  const { slug: storeSlug } = productSlugStore();
  const orderData = queryClient.getQueryData<ApiSuccessResponse<IOrder>>(['order']);

  if (paramSlug) return paramSlug;

  const isCartOrCheckout = pathname.startsWith('/carts') || pathname.startsWith('/checkout');
  if (isCartOrCheckout) {
    return orderData?.data?.line_items?.[0]?.product?.slug;
  }

  return storeSlug || undefined;
};
